export const GRID_SIZE: number = 12;
